export class PagingCriteria {
  offset: number;
  limit: number;
}
